import { render, staticRenderFns } from "./LangDropDown.vue?vue&type=template&id=3b32b776&scoped=true"
import script from "./LangDropDown.vue?vue&type=script&lang=js"
export * from "./LangDropDown.vue?vue&type=script&lang=js"
import style0 from "./LangDropDown.vue?vue&type=style&index=0&id=3b32b776&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b32b776",
  null
  
)

export default component.exports